import React from 'react';
import styled from 'styled-components';

const StyledCheckbox = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: ${props => props.size};
    text-align: left;

    input[type='checkbox'] {
        margin-right: 8px;
    }

    label {
        flex-basis: 80%;
        line-height: 1;
        margin-left: 8px;
    }
`;

const Checkbox = ({ children, id, label, labelSize }) => {
    return (
        <StyledCheckbox className="clx-step__checkbox" size={labelSize === 'small' ? '12px' : '14px'}>
            {children}
            <label htmlFor={id}>{label}</label>
        </StyledCheckbox>
    );
};

export default Checkbox;
